<app-common-table #child [params]="tableParams"></app-common-table>
